/*
 * File: index.ts
 * File Created: 2024-02-02 07:43:38
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-02 10:28:33
 * Modified By: Val Liu
 * -----
 */

// import { ALLOW_GENERAL_MODIFY, ALLOW_GENERAL_READ } from "@/helpers/permission-helper";
import { PARAMS_INCLUDE, PARAMS_WHERE } from "@/views/core";
import { IPermissionCheck, ObjectHelper, Vue } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";
// import { EMembershipRolePermission } from "shared-taiwan-bank-life-insurance";
const _ = UIQuick.getInstance;

// const rolePermission: EMembershipRolePermission = EMembershipRolePermission.系統維護管理作業;

@UIQuick.set()
export class Membership extends IQuickUnit {
    title = "w_MenuMembership";
    path = "/membership";
    icon = "fa-solid fa-person";

    /// hireachy
    parents = () => [_`Organization`];
    children = null;

    /// file
    file = false;

    /// params
    paramsWhere = PARAMS_WHERE;
    paramsRead = PARAMS_INCLUDE_USER;
    paramsUpdate = PARAMS_INCLUDE_USER;

    /// interfaces
    infDetail = require("raw-loader!./interfaces/membership.create.interface").default;
    infRead = require("raw-loader!./interfaces/membership.read.interface").default;
    infCreate = require("raw-loader!./interfaces/membership.create.interface").default;
    infUpdate = require("raw-loader!./interfaces/membership.create.interface").default;
    infDelete = require("raw-loader!./interfaces/membership.delete.interface").default;
}


function PARAMS_INCLUDE_USER(this) {
    return ObjectHelper.deepMerge(PARAMS_INCLUDE.call(this), {
        include: {
            user: true,
            organization: {
                include: {
                    _count: {
                        select: {
                            memberships: true,
                        },
                    },
                },
            },
        },
    });
}
